module.exports = __webpack_public_path__ + "static/media/Level-1.86a49daa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Level-1.svg
// module id = 1306
// module chunks = 0